import { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Link,
  Stack,
  Switch,
  Typography,
  createTheme,
  styled,
  useMediaQuery
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Icon } from '@iconify/react';
import { useAppDispatch, useAppSelector } from '../../../app/redux/hooks';
import { getLogin } from '../../../common/redux/reducer/commonSlices/loginSlice';
import constant from '../../../utils/constants';
import CustomTextField from '../../components/customized/customtextfield/CustomTextField';
import CustomButton from '../../components/buttons/CustomButton';
import Tracking from '../../../app/assets/images/landing/tracking.jpg';
import Tracker from '../../../app/assets/images/landing/tracker.jpg';
import YTLogo from '../../../app/assets/images/YaantracLogo.png';
import Drive from '../../../app/assets/images/landing/drive.png';
import Ayka from '../../../app/assets/images/landing/AYKA.png';
import { getCurrentToken } from '../../../firebase';
import { Navigate, useNavigate } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Login.scss';
// import { loginData } from './componentsDatas/loginDatas';
import {
  useAfterLoginNavigate,
  useLoginFormSubmission,
  useLoginStyle
} from './hooks/loginHooks';
import { useDynamicYupSchema } from '../../hooks/useDynamicSchema';
import { loginData } from './componentsDatas/loginDatas';

export const settings = {
  autoPlay: true,
  infiniteLoop: true,
  showThumbs: false,
  showArrows: false,
  swipeable: true,
  interval: 2000,
  showStatus: false,
  emulateTouch: false,
  centerMode: true,
  centerSlidePercentage: 100,
  stoponHover: true,
  width: '25%'
};

export const images = [
  { key: 'image', source: Drive },
  { key: 'image', source: Tracking },
  { key: 'image', source: Tracker }
];

function Login() {
  const { isLoading } = useAppSelector(state => state.auth);
  const themes = useAppSelector(state => state.theme.theme);

  const { createFormFields } = useDynamicYupSchema(null);
  const { schema } = createFormFields(loginData());

  const { handleSubmit, control } = useForm({ resolver: yupResolver(schema) });

  const {
    onSubmit,
    handleChange,
    isKeepSignedIn,
    handleForgetPw,
    navigate,
    dispatch,
    firbaseLoading
  } = useLoginFormSubmission();
  useAfterLoginNavigate();

  const { AntSwitch, SmallDevices } = useLoginStyle(themes);

  return (
    <Grid container className='grid-container'>
      <Box className='gradient-box'></Box>
      {!SmallDevices && (
        <>
          <Carousel className='my-carousel' {...settings}>
            {images.map((e: any) => {
              return (
                <Grid item className='login-image'>
                  {e.key === 'video' ? (
                    <video className='login-video' autoPlay loop muted>
                      <source
                        src={require('../../../app/assets/video/loginVideo.mp4')}
                        type='video/mp4'
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img src={e.source}></img>
                  )}
                </Grid>
              );
            })}
          </Carousel>
          <Box className='login-content'>
            <Typography className='login-heading-typo'>
              {constant.LoginHeading}
            </Typography>
            <Typography className='login-subhead-typo'>
              {constant.LoginSubHead}
            </Typography>
          </Box>
        </>
      )}
      <Grid
        item
        className='login-grid '
        sx={{
          left: SmallDevices ? '50%' : '70%',
          width: SmallDevices ? '100%' : '70%'
        }}
      >
        <ul className='circles'>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <Box
          className='login-box animate__animated animate__fadeInUp '
          component='form'
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box
            className='app-logo'
            component='img'
            src={themes === 'ayka' ? Ayka : YTLogo}
            onClick={() => navigate('/')}
          />

          <h2 className='login-header'>{constant.Login}</h2>

          <Box className='animate__animated animate__zoomInDown '>
            <CustomTextField
              label={constant.UserName}
              id='username'
              placeholder='Username'
              control={control}
              name='userID'
              icon={
                <Icon icon='ep:user' width='15' height='15' style={{ color: 'black' }} />
              }
              autoComplete='on'
            />
          </Box>
          <Box my={2}></Box>
          <Box className='animate__animated animate__zoomInDown animate__delay-0.9s'>
            <CustomTextField
              label={constant.Password}
              id='password'
              type='password'
              placeholder='Password'
              control={control}
              name='password'
              icon={
                <Icon
                  icon='teenyicons:lock-outline'
                  width='15'
                  height='15'
                  style={{ color: 'black' }}
                />
              }
              autoComplete='on'
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '15px',
              justifyContent: 'space-between'
            }}
          >
            <Box className='switch-box'>
              <Stack direction='row' spacing={1} alignItems='center'>
                <AntSwitch
                  inputProps={{ 'aria-label': 'ant design' }}
                  className='ant-switch'
                  checked={isKeepSignedIn}
                  onChange={handleChange}
                />
              </Stack>

              <p className='keep-sign'>{constant.KeepSign}</p>
            </Box>
            <Box onClick={handleForgetPw}>
              <Link underline='none' className='forgot-pw'>
                {`${constant.ForgotPassword}?`}
              </Link>
            </Box>
          </Box>
          <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
            <CustomButton
              loading={isLoading || firbaseLoading}
              category='Login'
              className='custom-button'
              type='submit'
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Login;
